import React from "react";
import { IIcon } from "./Icon.types";

const ForwardIcon: React.FC<IIcon> = ({
  width = "32",
  height = "32",
  fill = "#FFFFFF",
  viewBox = "0 0 32 32",
  onClick,
  className,
}: IIcon): React.JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      stroke={fill}
      viewBox={viewBox}
      onClick={onClick}
      className={className}
      data-testid="forwardIcon"
    >
      <path
        d="M17.5 7L14 7C12.22 7 10.4799 7.52784 8.99987 8.51677C7.51983 9.50571 6.36628 10.9113 5.68509 12.5558C5.0039 14.2004 4.82567 16.01 5.17294 17.7558C5.5202 19.5016 6.37737 21.1053 7.63604 22.364C8.89472 23.6226 10.4984 24.4798 12.2442 24.8271C12.8252 24.9426 13.4133 25 14 25"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14 3L18 7L14 11"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19 3L23 7L19 11"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M20.1289 16V24H18.4375V17.6055H18.3906L16.5586 18.7539V17.2539L18.5391 16H20.1289ZM24.727 24.1758C24.0551 24.1732 23.477 24.0078 22.9926 23.6797C22.5108 23.3516 22.1398 22.8763 21.8793 22.2539C21.6215 21.6315 21.4939 20.8828 21.4965 20.0078C21.4965 19.1354 21.6254 18.3919 21.8832 17.7773C22.1437 17.1628 22.5148 16.6953 22.9965 16.375C23.4809 16.0521 24.0577 15.8906 24.727 15.8906C25.3963 15.8906 25.9718 16.0521 26.4536 16.375C26.9379 16.6979 27.3103 17.1667 27.5707 17.7812C27.8312 18.3932 27.9601 19.1354 27.9575 20.0078C27.9575 20.8854 27.8273 21.6354 27.5668 22.2578C27.309 22.8802 26.9392 23.3555 26.4575 23.6836C25.9757 24.0117 25.3989 24.1758 24.727 24.1758ZM24.727 22.7734C25.1853 22.7734 25.5512 22.543 25.8246 22.082C26.0981 21.6211 26.2335 20.9297 26.2309 20.0078C26.2309 19.401 26.1684 18.8958 26.0434 18.4922C25.921 18.0885 25.7465 17.7852 25.52 17.582C25.296 17.3789 25.0317 17.2773 24.727 17.2773C24.2713 17.2773 23.9067 17.5052 23.6332 17.9609C23.3598 18.4167 23.2218 19.099 23.2192 20.0078C23.2192 20.6224 23.2804 21.1354 23.4028 21.5469C23.5278 21.9557 23.7036 22.263 23.9301 22.4687C24.1567 22.6719 24.4223 22.7734 24.727 22.7734Z"
        fill="white"
      />
    </svg>
  );
};

export default ForwardIcon;